// extracted by mini-css-extract-plugin
export default {"div":"Contact_div__+pDkc","heading":"Contact_heading__X1hSW","content":"Contact_content__TswrA","article":"Contact_article__2xTVj","form":"Contact_form__y2x5b"};